export const contact = {
  name: 'Motor City Truck Collision',
  phoneDisplay: '248-986-8000',
  phoneHref: 'tel:+12489868000',
  street: '12264 Emerson Dr.',
  cityLine: 'Brighton, MI 48116',
};

export const urls = {
  quote: 'https://www.motorcitytruckcollision.com/request-a-quote.html',
  collision: 'https://www.motorcitytruckcollision.com/heavytruckcollisionbodyshop.html',
  rv: 'https://www.motorcitytruckcollision.com/RV-Repair',
  trailer: 'https://www.motorcitytruckcollision.com/Trailer-Repair',
  liftgate: 'https://www.motorcitytruckcollision.com/Lift-Gate-Repair',
  serviceBody: 'https://www.motorcitytruckcollision.com/Service-Body-Repair',
  wraps: 'https://www.motorcitytruckcollision.com/CommercialVehicleGraphicWraps.html',
  blasting: 'https://www.motorcitytruckcollision.com/dustless-sandblasting.html',
  payment: 'https://www.motorcitytruckcollision.com/18.html',
  careers: 'https://www.motorcitytruckcollision.com/Body-Shop-Jobs',
  semi: 'https://www.motorcitytruckcollision.com/Semi-Truck-Body-Shop',
  boxTruck: 'https://www.motorcitytruckcollision.com/box-truck-repair.html',
  paint: 'https://www.motorcitytruckcollision.com/Commercial-Truck-Paint-Shop',
  fleet: 'https://www.motorcitytruckcollision.com/Fleet-Truck-Body-Repair',
  gallery: 'https://www.motorcitytruckcollision.com/ourrepairwork.html',
  contact: 'https://www.motorcitytruckcollision.com/contact-motor-city-truck-collision.html',
  heavyEquipment: 'https://www.motorcitytruckcollision.com/earthmoving-equipment-restoration-paint-repair.html',
  garrett: 'https://www.garrettauto.com/',
  directions:
    'https://www.google.com/maps/search/?api=1&query=12264%20Emerson%20Dr.%2C%20Brighton%2C%20MI%2048116',
};

export const images = {
  logo: 'https://drwzpk38qkpfb.cloudfront.net/www.motorcitytruckcollision.com/uploaded/images/header/widestroke2.png',
  hero: 'https://cdn.magicpatterns.com/uploads/daqjtkibJsXhv49pyTCsSc/hero-semi-cul-de-sac-ai-v2.webp',
  boxTruck: 'https://www.motorcitytruckcollision.com/uploaded/images/Collision/Box-Truck-Repair/box-truck-repairs-418.jpg',
  hood: 'https://www.motorcitytruckcollision.com/uploaded/images/moto_city_gallery/10_IMG_0033_2.jpg',
  cab: 'https://www.motorcitytruckcollision.com/uploaded/images/moto_city_gallery/11_IMG_0100.jpg',
  workTruck: 'https://www.motorcitytruckcollision.com/uploaded/images/moto_city_gallery/12_IMG_0184.jpg',
  garrettLogo: 'https://drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/NewDesign/logo_black_bg.jpg',
  paintBooth: 'https://www.motorcitytruckcollision.com/uploaded/images/special_projects.png',
};
